// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c26ab9ce","977":"2cfa8a79"}[chunkId] + ".chunk.js";
};